export var BenefitEnquiries;
(function (BenefitEnquiries) {
    BenefitEnquiries["Other"] = "OTHER";
    BenefitEnquiries["ProportionsInAssetsPurchased"] = "PROPORTION_IN_ASSETS_PURCHASED";
    BenefitEnquiries["RepayDebtsOrOtherObligations"] = "REPAY_DEBTS_OR_OTHER_OBLIGATIONS";
})(BenefitEnquiries || (BenefitEnquiries = {}));
export var CoApplicantBenefit;
(function (CoApplicantBenefit) {
    CoApplicantBenefit["NoSubstantialBenefit"] = "NO_SUBSTANTIAL_BENEFIT";
    CoApplicantBenefit["NoSubstantialBenefitAndProceed"] = "NO_SUBSTANTIAL_BENEFIT_AND_PROCEED";
    CoApplicantBenefit["SubstantialBenefit"] = "SUBSTANTIAL_BENEFIT";
})(CoApplicantBenefit || (CoApplicantBenefit = {}));
export var CoApplicantReason;
(function (CoApplicantReason) {
    CoApplicantReason["AccessToCashOrEquity"] = "ACCESS_TO_CASH_OR_EQUITY";
    CoApplicantReason["BuyingAVehicalWhereOnlyOneBorrowerCanBeTheRegisteredOwner"] = "BUYING_A_VEHICLE_WHERE_ONLY_ONE_BORROWER_CAN_BE_THE_REGISTERED_OWNER";
    CoApplicantReason["IndependentFinancialLegalOrAccountingAdviceRequired"] = "INDEPENDENT_FINANCIAL_LEGAL_OR_ACCOUNTING_ADVICE_RECEIVED";
    CoApplicantReason["SpousalAssetProtectionTaxBenefitsOrDebtReduction"] = "SPOUSAL_ASSET_PROTECTION_TAX_BENEFITS_OR_DEBT_REDUCTION";
    CoApplicantReason["SubstantialBenefitFromAtLeastOneOfTheLoanPurposes"] = "SUBSTANTIAL_BENEFIT_FROM_AT_LEAST_ONE_OF_THE_LOAN_PURPOSES";
})(CoApplicantReason || (CoApplicantReason = {}));
export var DocumentationDeliveryMethod;
(function (DocumentationDeliveryMethod) {
    DocumentationDeliveryMethod["email"] = "EMAIL";
    DocumentationDeliveryMethod["post"] = "POST";
    DocumentationDeliveryMethod["collectFromNearestBranch"] = "COLLECT_FROM_NEAREST_BRANCH";
})(DocumentationDeliveryMethod || (DocumentationDeliveryMethod = {}));
export var GuarantorLocationType;
(function (GuarantorLocationType) {
    GuarantorLocationType["lendiApprovedPhotoInterview"] = "LENDI_APPROVED_PHONE_INTERVIEW";
    GuarantorLocationType["faceToFace"] = "FACE_TO_FACE";
})(GuarantorLocationType || (GuarantorLocationType = {}));
export var IndependentAdviceTypeRequired;
(function (IndependentAdviceTypeRequired) {
    IndependentAdviceTypeRequired["legalAdvice"] = "LEGAL_ADVICE";
    IndependentAdviceTypeRequired["financialAdvice"] = "FINANCIAL_ADVICE";
    IndependentAdviceTypeRequired["notNeeded"] = "NOT_NEEDED";
})(IndependentAdviceTypeRequired || (IndependentAdviceTypeRequired = {}));
export var LocationType;
(function (LocationType) {
    LocationType["CustomerResidence"] = "CUSTOMER_RESIDENCE";
    LocationType["LendiApprovedPhoneInterview"] = "LENDI_APPROVED_PHONE_INTERVIEW";
    LocationType["Other"] = "OTHER";
})(LocationType || (LocationType = {}));
//# sourceMappingURL=BrokerInterviews.js.map